/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByCategoryKind = (typeof GroupByCategoryKind)[keyof typeof GroupByCategoryKind];

export const GroupByCategoryKind = {
  category: 'category',
} as const;
